import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { 
  Box, Container, Typography, FormControlLabel, Switch,
  Backdrop, CircularProgress, Card, Stack, Avatar
} from '@mui/material';
import { 
  ViewList as ViewListIcon, 
  Summarize as SummarizeIcon,
  AccountBalanceWallet as WalletIcon 
} from '@mui/icons-material';

// import { baseUrl, config, requestID } from "../common/utils";
// import StockDashboard, { StockItem } from '../components/StockDashboard';
import { IonContent, IonPage } from '@ionic/react';
import { requestID, baseUrl, config } from '../../../common/utils';
import StockDashboard from '../../../components/StockDashboard';
import { StockItem } from '../../../models/stocks';

const InventoryManagement: React.FC = () => {
  const [stockList, setStockList] = useState<StockItem[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [viewMode, setViewMode] = useState<'detailed' | 'master'>('detailed');
  const [totalValuation, setTotalValuation] = useState(0);

  const fetchData = async () => {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("requestID", requestID());
      
      const endpoint = viewMode === 'master' 
        ? `${baseUrl()}Geacloud_Inventorys/getMasterStockLevels` 
        : `${baseUrl()}Geacloud_Inventorys/getStockLevels`;

      const stockRes = await axios.post(endpoint, formData, config);
      const valRes = await axios.post(`${baseUrl()}Geacloud_Inventorys/getInventoryStats`, formData, config);

      if (stockRes.data.status === true) setStockList(stockRes.data.data);
      if (valRes.data.status === true) setTotalValuation(valRes.data.data.total_valuation);
      
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [viewMode]);

  return (
    <IonPage>
      <IonContent>
<Box sx={{ backgroundColor: '#f5f7fb', height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      {/* HEADER */}
      <Box sx={{ background: 'linear-gradient(to right, #1e3a8a, #2563eb)', px: 3, py: 4, boxShadow: '0 4px 12px rgba(37,99,235,0.2)', zIndex: 10 }}>
        <Container maxWidth="xl">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
              <Box>
                <Typography variant="h4" fontWeight={700} sx={{ color: 'white' }}>Inventory Control</Typography>
                <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.8)', mt: 0.5 }}>Real-time stock levels and asset valuation.</Typography>
              </Box>

              <Stack direction="row" spacing={3} alignItems="center">
                {/* VALUATION CARD IN HEADER */}
                <Card sx={{ bgcolor: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(10px)', color: 'white', p: 1.5, px: 3, border: '1px solid rgba(255,255,255,0.2)' }}>
                   <Stack direction="row" spacing={2} alignItems="center">
                      <Avatar sx={{ bgcolor: '#10b981', width: 32, height: 32 }}><WalletIcon sx={{ fontSize: 18 }}/></Avatar>
                      <Box>
                         <Typography variant="caption" sx={{ display: 'block', opacity: 0.8, lineHeight: 1 }}>Total Valuation</Typography>
                         <Typography variant="h6" fontWeight={700}>₦{Number(totalValuation).toLocaleString()}</Typography>
                      </Box>
                   </Stack>
                </Card>

                <Box sx={{ bgcolor: 'rgba(255,255,255,0.1)', p: 1, borderRadius: 2 }}>
                   <FormControlLabel
                      control={
                          <Switch 
                              checked={viewMode === 'master'}
                              onChange={(e) => setViewMode(e.target.checked ? 'master' : 'detailed')}
                              color="default"
                          />
                      }
                      label={
                          <Typography variant="body2" sx={{ color: 'white', fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1 }}>
                              {viewMode === 'master' ? <SummarizeIcon fontSize="small"/> : <ViewListIcon fontSize="small"/>}
                              {viewMode === 'master' ? 'Consolidated' : 'Detailed'}
                          </Typography>
                      }
                      sx={{ mr: 0, ml: 1 }}
                   />
                </Box>
              </Stack>
          </Box>
        </Container>
      </Box>

      {/* DASHBOARD CONTENT */}
      <Box sx={{ flex: 1, overflowY: 'auto', p: 3 }}>
  <Container maxWidth="xl" sx={{ mt: 2, mb: 8 }}>
      <StockDashboard 
        stocks={stockList} 
        loading={loading} 
        onRefresh={fetchData} 
        onTransfer={(item) => {
          console.log("Transfer requested for:", item.stock_name);
        }} 
      />
  </Container>
</Box>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
      </IonContent>
    </IonPage>
    
  );
};

export default InventoryManagement;